(() => {
  function init(scope = document) {
    scope.querySelectorAll('.ay-home-product-form').forEach(form => {
      if (form.dataset.optionsReady) return;
      const data = form.querySelector('[data-home-variants]');
      if (!data) return;
      const config = JSON.parse(data.textContent);
      if (config.options.length < 2) return;
      form.dataset.optionsReady = 'true';
      const native = form.querySelector('select[name="id"]');
      const submit = form.querySelector('[type="submit"]');
      const group = document.createElement('div');
      group.className = 'ay-home-option-groups';
      const controls = config.options.map((name, index) => {
        const label = document.createElement('label');
        const select = document.createElement('select');
        select.id = native.id + '-option-' + index;
        select.required = true;
        label.htmlFor = select.id;
        label.textContent = name;
        group.append(label, select);
        return select;
      });
      const refresh = start => {
        controls.forEach((select, index) => {
          if (index < start) return;
          const previous = select.value;
          const candidates = config.variants.filter(variant => variant.options.every((value, i) => i >= index || value === controls[i].value));
          const values = [...new Set(candidates.map(variant => variant.options[index]))];
          select.replaceChildren(new Option(config.choose, ''));
          values.forEach(value => select.add(new Option(value, value)));
          if (values.includes(previous)) select.value = previous;
          select.disabled = index > 0 && !controls[index - 1].value;
        });
        const variant = config.variants.find(variant => variant.options.every((value, i) => value === controls[i].value));
        native.value = variant ? String(variant.id) : '';
        submit.disabled = !variant;
      };
      controls.forEach((select, index) => select.addEventListener('change', () => refresh(index + 1)));
      native.before(group);
      native.hidden = true;
      native.required = false;
      form.querySelector('label[for="' + native.id + '"]').hidden = true;
      refresh(0);
    });
    scope.querySelectorAll('[data-ay-set-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const card = form.closest('.ay-set-card');
      const selects = [...form.querySelectorAll('[data-set-variant]')];
      const button = form.querySelector('[data-set-submit]');
      const status = form.querySelector('[data-set-status]');
      const en = document.documentElement.lang.startsWith('en');
      const root = window.Shopify?.routes?.root || (en ? '/en/' : '/');
      const currency = card.closest('[data-ay-home-currency]')?.dataset.ayHomeCurrency || document.querySelector('[data-ay-home-currency]')?.dataset.ayHomeCurrency || 'CAD';
      const formatPrice = total => window.ayMoney ? window.ayMoney(total) : new Intl.NumberFormat(en ? 'en-CA' : 'fr-CA', { style: 'currency', currency }).format(total / 100);
      form.addEventListener('change', () => {
        const total = selects.reduce((sum, select) => {
          const option = select.selectedOptions[0];
          return sum + Number(option?.dataset.price || (select.hasAttribute('data-set-optional') ? 0 : select.options[1]?.dataset.minPrice) || 0);
        }, 0);
        card.querySelector('[data-set-price]').textContent = formatPrice(total);
        const count = Number(button.dataset.baseCount || selects.filter(select => !select.hasAttribute('data-set-optional')).length) + selects.filter(select => select.hasAttribute('data-set-optional') && select.value).length;
        if (!button.disabled) button.textContent = en ? `Add the ${count} pieces` : `Ajouter les ${count} pièces`;
        status.textContent = '';
      });
      selects.filter(select => !select.hasAttribute('data-set-optional')).forEach(select => {
        if (!select.value && select.options.length > 1) select.selectedIndex = 1;
      });
      form.dispatchEvent(new Event('change', { bubbles: true }));
      let busy = false;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        busy = true; button.disabled = true; form.setAttribute('aria-busy', 'true');
        status.textContent = en ? 'Adding your set…' : 'Ajout de votre ensemble…';
        try {
          const items = selects.filter(select => select.value).map(select => ({ id: Number(select.value), quantity: 1, properties: { 'Ensemble A&Y': form.dataset.setTitle } }));
          const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : (en ? 'Please check availability before trying again.' : 'Vérifiez la disponibilité avant de réessayer.'));
          window.location.assign(root + 'cart');
        } catch (error) {
          status.replaceChildren(document.createTextNode(error.message + ' '));
          const link = document.createElement('a'); link.href = root + 'cart'; link.textContent = en ? 'Check your cart' : 'Vérifier votre panier'; status.append(link);
          button.disabled = false; busy = false; form.removeAttribute('aria-busy');
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
